// useAuth.tsx
import { useAuth as useAuthContext } from 'Context/AuthProvider';

export const useAuth = () => useAuthContext();